<template>
  <div id="donation" ref="index">
    <!-- kv -->
    <kv :banner="banner"></kv>
    <!-- 捐款方式 -->
    <section class="method" data-aos="fade-up" data-aos-once="true" ref="method">
      <div class="container">
        <h2 class="text-secondary">捐款資訊</h2>
        <div class="row">
          <div
            v-for="(item, index) in usages"
            :key="index"
            class="col-lg-4 col-sm-6"
            data-aos="flip-up"
            data-aos-once="true"
            :data-aos-delay="index*100"
          >
            <div
              class="method-box d-flex flex-column align-items-center"
              :class="{'active':detail===item.id}"
              @click.prevent="showDetail(item.id)"
            >
              <div class="method-img d-flex align-items-center justify-content-center">
                <img
                  v-if="item.media.data.length>0"
                  v-lazy="item.media.data[0].original"
                  class="rounded"
                  :key="item.id"
                />
              </div>
              <h5 class="method-title">{{item.title}}</h5>
              <div
                v-show="detail===item.id"
                class="method-desc pt-10 pb-30 mx-20"
                v-html="item.content"
              ></div>
              <div v-if="detail===item.id && item.media.data.length>1" class="method-img-2">
                <img v-lazy="item.media.data[1].original" class="rounded" :key="`${item.id}-2`" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 捐物資訊 -->
    <section class="supplies" data-aos="fade-up" data-aos-once="true" ref="supplies">
      <div class="container">
        <h2 class="text-secondary">捐物資訊</h2>
        <div class="row mt-30">
          <div
            v-for="(item, index) in supplies"
            :key="index"
            class="col-lg-4 col-md-6 mb-50 mb-md-30 mb-lg-0"
          >
            <div class="supplies-box h-100">
              <h4 class="supplies-title text-center text-primary">{{item.title}}</h4>
              <div class="supplies-info" v-html="item.content"></div>
            </div>
          </div>
          <div class="supplies-details col-12 col-sm-8 ml-auto mt-0 mt-sm-40">
            <ul class="p-0">
              <li class="d-flex align-items-center my-20">請直接郵寄或親送至新北市泰山區新生路4號</li>
              <li class="d-flex align-items-center my-20">若假日親送或其他捐贈疑問請電洽：02-29062242分機334、321</li>
              <li class="d-flex align-items-center my-20">請註明寄件人姓名、電話、地址以利開立捐物收據</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- 捐款名單 -->
    <section class="list" data-aos="fade-up" data-aos-once="true" ref="list">
      <div class="container-md">
        <h2 class="text-secondary mt-15 mb-25">捐贈芳名錄</h2>
        <div class="row">
          <div class="col-lg-8">
            <div class="list-box">
              <div class="list-header">
                <h4 class="mt-20 mb-0 pb-20 text-center">捐贈芳名錄</h4>
              </div>
              <div class="list-body">
                <div class="list-search">
                  <form class="form-inline">
                    <label class="my-5 mr-20" for="search-name">姓名</label>
                    <input
                      id="search-name"
                      type="text"
                      class="form-control"
                      v-model="searchData.search"
                      placeholder="請輸入姓名"
                      @keyup.enter="()=>{searchData.page=1; getList(searchData)}"
                      @keyup.delete="()=>{searchData.page=1; getList(searchData)}"
                    />
                    <button
                      type="submit"
                      class="btn btn-sub-primary text-white ml-auto my-5 w-25"
                      @click.prevent="()=>{searchData.page=1; getList(searchData)}"
                    >查詢</button>
                  </form>
                </div>
                <div class="list-result d-flex flex-column justify-content-between" ref="list">
                  <div class="d-flex flex-column align-items-center justify-content-center">
                    <h6
                      class="w-100 py-15 m-0 text-center text-sub-primary bg-sub-primary-white"
                    >搜尋結果</h6>
                    <table class="table" v-if="screenWidth>=576">
                      <thead>
                        <tr>
                          <th scope="col" width="20%">捐贈日期</th>
                          <th scope="col">捐贈者</th>
                          <th scope="col" width="12%">物品</th>
                          <th scope="col" width="12%">數量</th>
                          <th scope="col" width="10%">單位</th>
                          <th scope="col" width="15%">收據編號</th>
                        </tr>
                      </thead>
                      <tbody v-if="searchList.length>0">
                        <tr v-for="(item, index) in searchList" :key="index">
                          <td>{{item.donated_at | date}}</td>
                          <td>{{item.name}}</td>
                          <td>{{item.items||''}}</td>
                          <td>{{item.quantity}}</td>
                          <td>{{item.unit}}</td>
                          <td>{{item.receipt}}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="6" class="text-center text-sub-primary">查無資訊</td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      class="table table-sm my-10"
                      v-else
                      v-for="(item, index) in searchList"
                      :key="index"
                    >
                      <tbody v-if="searchList.length>0">
                        <tr>
                          <td>捐贈日期</td>
                          <td>{{item.donated_at | date}}</td>
                        </tr>
                        <tr>
                          <td>捐贈者</td>
                          <td>{{item.name}}</td>
                        </tr>
                        <tr>
                          <td>物 品</td>
                          <td>{{item.items||''}}</td>
                        </tr>
                        <tr>
                          <td>數 量</td>
                          <td>{{item.quantity}}</td>
                        </tr>
                        <tr>
                          <td>單 位</td>
                          <td>{{item.unit}}</td>
                        </tr>
                        <tr>
                          <td>收據編號</td>
                          <td>{{item.receipt}}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="2" class="text-center text-sub-primary">查無資訊</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <nav aria-label="Page navigation example">
                    <ul class="pagination d-flex align-items-center justify-content-center">
                      <li class="page-item" :class="{'disabled':pagination.current_page===1}">
                        <a
                          class="page-link p-0 h-100 d-flex align-items-center justify-content-center text-primary"
                          href="#"
                          @click.prevent="searchData.page=1"
                        >
                          <i class="material-icons">first_page</i>
                        </a>
                      </li>
                      <li class="page-item" :class="{'disabled':pagination.current_page===1}">
                        <a
                          class="page-link p-0 h-100 d-flex align-items-center justify-content-center text-primary"
                          href="#"
                          @click.prevent="searchData.page=searchData.page-1"
                        >
                          <i class="material-icons">keyboard_arrow_left</i>
                        </a>
                      </li>
                      <li class="page-item" v-for="(item, index) in pageIndex" :key="index">
                        <a
                          class="page-link"
                          :class="{'active': pagination.current_page===item}"
                          href="#"
                          @click.prevent="searchData.page=item"
                        >{{item}}</a>
                      </li>
                      <li
                        class="page-item"
                        :class="{'disabled':pagination.current_page===pagination.total_pages}"
                      >
                        <a
                          class="page-link p-0 h-100 d-flex align-items-center justify-content-center text-primary"
                          href="#"
                          @click.prevent="searchData.page=searchData.page+1"
                        >
                          <i class="material-icons">keyboard_arrow_right</i>
                        </a>
                      </li>
                      <li
                        class="page-item"
                        :class="{'disabled':pagination.current_page===pagination.total_pages}"
                      >
                        <a
                          class="page-link p-0 h-100 d-flex align-items-center justify-content-center text-primary"
                          href="#"
                          @click.prevent="searchData.page=pagination.total_pages"
                        >
                          <i class="material-icons">last_page</i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <div
            class="donation-greet col-lg-4 d-flex flex-column align-items-center justify-content-center"
          >
            <p class="slogan text-center m-0 px-10">感謝您的支持與勉勵，成為奇蹟之家在守護之路上的力量，也督促著我們注入更多希望。</p>
            <p class="contact text-center">
              <small>
                每月月初更新，倘若查詢不到
                <br />請電洽02-29062242分機334、321
              </small>
            </p>
          </div>
        </div>
      </div>
    </section>
    <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import kv from '@/components/kv.vue';

export default {
  name: 'donation',
  metaInfo: {
    title: ' - 捐款資訊',
  },
  components: {
    kv,
  },
  data() {
    return {
      banner: [],
      usages: [],
      supplies: [],
      detail: false,
      searchList: [],
      searchData: {
        search: '',
        searchFields: 'name',
        page: 1,
      },
      pagination: {},
    };
  },
  computed: {
    ...mapGetters(['screenWidth']),
    kv_id() {
      return this.screenWidth >= 576 ? 4 : 9;
    },
    limit() {
      return this.screenWidth >= 576 ? 15 : 5;
    },
    pageIndex() {
      const current = this.pagination.current_page;
      const total = this.pagination.total_pages;
      if (total <= 5) {
        const page = [];
        for (let i = 1; i <= total; i += 1) {
          page.push(i);
        }
        return page;
      }
      if (current >= 4) {
        if (current <= total - 2) {
          return [current - 2, current - 1, current, current + 1, current + 2];
        }
        return [total - 4, total - 3, total - 2, total - 1, total];
      }
      const page = [];
      for (let i = 1; i <= 5; i += 1) {
        page.push(i);
      }
      return page;
    },
  },
  methods: {
    showDetail(id) {
      if (id === 29) {
        window.open('https://miracle-esc.eoffering.org.tw', '_blank');
      } else {
        this.detail = (this.detail === id) ? false : id;
      }
    },
    getBanner() {
      const url = `/banner/${this.kv_id}`;
      this.axios
        .get(url)
        .then((response) => {
          this.banner = response.data.data.file.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getUsage() {
      const url = '/article';
      const params = {
        search: 15,
        searchFields: 'category_id',
        sortedBy: 'desc',
        limit: 15,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.usages = response.data.data;
          this.usages.forEach((item) => {
            if (item.content.match(/^pre/g) !== undefined) {
              item.content = item.content.replace(new RegExp('pre>', 'ig'), 'div>');
            }
          });
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getSupplies() {
      const url = '/article';
      const params = {
        search: 16,
        searchFields: 'category_id',
        sortedBy: 'asc',
        limit: 15,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.supplies = response.data.data;
          this.supplies.forEach((item) => {
            if (item.content.match(/^pre/g) !== undefined) {
              item.content = item.content.replace(new RegExp('pre>', 'ig'), 'div>');
            }
          });
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getList(search) {
      const loading = this.$loading.show({
        container: this.$refs.list,
      });
      const url = '/donate';
      const params = {
        ...search,
        orderBy: 'donated_at;id',
        sortedBy: 'desc;desc',
        limit: this.limit,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.searchList = response.data.data;
          this.pagination = response.data.meta.pagination;
          loading.hide();
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
          loading.hide();
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getBanner();
    this.getUsage();
    this.getSupplies();
    this.getList();
    if (this.$route.params.id) {
      const target = this.$route.params.id;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[target].scrollIntoView();
        }, 800);
      });
    } else {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToTop();
        }, 500);
      });
    }
  },
  watch: {
    detail(val) {
      this.detail = val;
    },
    'searchData.page': function changePage() {
      this.getList(this.searchData);
    },
    kv_id() {
      this.getBanner();
    },
    limit() {
      this.getList();
    },
    pagination() {},
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/all.scss';

#donation {
  // width: calc(100vw - 5px);
  // overflow-x: hidden;
  section:not(.hooper):not(.kv) {
    min-height: 450px;
    padding: 40px 0;
    a {
      color: #000000;
      text-decoration: none;
    }
    .section-title {
      color: $secondary;
      position: relative;
      z-index: 1;
      &::before {
        position: absolute;
        content: '';
        height: 5px;
        background-color: $primary;
        opacity: 0.3;
        right: 0;
        left: 0;
        top: 12px;
        z-index: -1;
      }
    }
    // 捐款方式
    &.method {
      padding: 50px 0;
      .method-box {
        cursor: pointer;
        background-color: $primary-white;

        margin-top: 30px;
        transition: 0.5s ease-in-out;
        &:hover,
        &:focus,
        &.active {
          background-color: $primary;
          color: white;
          .method-img {
            background-color: $primary-white;
          }
        }
        .method-img {
          width: 180px;
          height: 180px;
          padding: 30px;
          // margin-top: 20px;
          margin: 20px 80px 0;
          border-radius: 50%;
          img {
            width: 80%;
            height: auto;
          }
        }
        .method-img-2 {
          width: 300px;
          height: auto;
          padding: 0 30px 30px;
          border-radius: 50%;
          img {
            width: 100%;
            height: auto;
          }
        }
        .method-title {
          margin: 20px 0 30px;
          letter-spacing: 5px;
        }
        .method-desc {
          line-height: 1.75em;
          letter-spacing: 1.5px;
        }
      }
    }
    // 捐物資訊
    &.supplies {
      background-color: $sub-primary-white;
      background-image: url('~@/assets/images/donation-hand.png');
      background-size: 400px auto;
      background-repeat: no-repeat;
      background-position: 5% 110%;
      @media (min-width: 768px) {
        background-position: 5% 118%;
      }
      .supplies-box {
        border: solid 10px $sub-primary;
        padding: 30px;
        .supplies-title {
          background-color: $sub-primary-white;
          margin: -50px 70px 30px;
        }
        .supplies-info {
          line-height: 1.75rem;
          letter-spacing: 1px;
        }
      }
      .supplies-details {
        background-color: adjust-color($color: $sub-primary-white, $alpha: -0.6);
        ul {
          list-style: none;
          li::before {
            content: '';
            display: inline-block;
            width: 16px;
            height: 16px;
            background-color: $primary;
            margin-right: 10px;
          }
          li {
            letter-spacing: 1px;
          }
        }
      }
    }
    // 捐款名錄
    &.list {
      .list-header {
        border: 30px solid $primary;
        border-top: 43px solid $primary;
        border-bottom: none;
      }
      // todo
      .list-body {
        padding: 30px;
        box-shadow: 0px 3px 3px lighten($secondary-light, 5%);
        .list-result {
          padding-top: 50px;
          // min-height: 610px;
          min-height: 450px;
          @media (min-width: 992px) {
          }
          table {
            color: $secondary;
            width: 100%;
            thead {
              background-color: lighten($primary-white, 5%);
              th {
                font-weight: 500;
                border: none;
                padding: 5px;
              }
            }
            td {
              font-size:14px;
              vertical-align: middle;
              padding: 5px;
            }
            &.table-sm {
              tbody {
                tr {
                  td:first-of-type {
                    background-color: lighten($primary-white, 5%);
                    width: 35%;
                    padding: 10px;
                    border: none;
                  }
                  td:last-of-type {
                    padding: 10px 20px;
                    border-top: none;
                    border-bottom: 2px dashed $secondary-white;
                  }
                }
              }
            }
          }
        }
      }
      .donation-greet {
        background-image: url('~@/assets/images/donation_leaves.png');
        background-position: center center;
        background-size: auto 100%;
        margin-top: 30px;
        margin-bottom: 50px;
        @media (min-width: 576px) {
          margin-bottom: 100;
        }
        @media (min-width: 992px) {
          background-size: 100% auto;
          margin-top: 0;
        }
        background-repeat: no-repeat;
        position: relative;
        min-height: 500px;
        .slogan {
          font-size: 20px;
          max-width: 500px;
          font-weight: 400;
        }
        .contact {
          position: absolute;
          bottom: -5%;
          @media (min-width: 992px) {
            bottom: 2%;
          }
        }
      }
      .pagination {
        a {
          border: none;
          &:hover,
          &.active {
            color: $sub-primary;
          }
        }
      }
    }
  }
}
</style>
